var render = function render(){var _vm=this,_c=_vm._self._c;return _c('drawer',{attrs:{"title":"Add note"},on:{"updateClose":_vm.onClose,"updateSave":_vm.onSave}},[_c('field',{attrs:{"margin":"0","width":"300px","min-height":"54px","label":"Note","placeholder":"Enter note","setInputValue":_vm.notes,"is-textarea":""},on:{"updateInput":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }